import styled from 'styled-components';
import NumberFormat from 'react-number-format';

import { TableGrid } from 'pages/aprovacao-detalhes/FormSecondSection/styles';

export const Container = styled(TableGrid)`
  width: 100%;
  background-color: #fff;
  border-radius: 4px;
  align-items: center;
  margin-bottom: 10px;
  padding: 10px 0;
  border: 1px solid transparent;

  &:hover {
    border: 1px solid #4a90e2;
  }

  span {
    font-weight: 300;
    font-size: 12px;
    line-height: 13px;

    color: #7a8799;
  }

  .input-vacancies-qtd {
    background-color: #fff;
    -webkit-appearance: none;
    box-shadow: none !important;
    outline: none;
    width: 65px;
    border: 0;
    border-bottom: 1px solid rgba(122, 135, 153, 0.7);

    font-weight: 300;
    font-size: 12px;
    line-height: 13px;
    color: #7a8799;
    padding-bottom: 3px;
  }

  .trash-icon {
    display: flex;
    align-items: center;
    color: #4a90e2;
    cursor: pointer;
    font-weight: 300;
    font-size: 12px;
    line-height: 13px;
    margin-right: 10px;

    img {
      width: 14px;
      margin-right: 8px;
    }
  }
`;

export const CourseInfo = styled.div`
  display: flex;
  padding: 0 18px;
  align-items: center;

  input {
    cursor: pointer;
  }

  label {
    margin: 0 0 0 18px;
    font-weight: 300;
    font-size: 12px;
    line-height: 13px;
    color: #7a8799;
    cursor: pointer;
  }

  span {
    font-style: normal;
    font-weight: 500;
    font-size: 10px;
    line-height: 11px;
    color: #98a2b2;
    margin-left: 8px;
  }
`;

export const TableItem = styled(TableGrid)`
  width: 100%;
  background-color: #fff;
  border-radius: 4px;
  align-items: center;
  margin-bottom: 10px;
  padding: 10px 0;
  border: 1px solid transparent;

  &:hover {
    border: 1px solid #4a90e2;
  }

  span {
    font-weight: 300;
    font-size: 12px;
    line-height: 13px;

    color: #7a8799;
  }

  .input-vacancies-qtd {
    background-color: #fff;
    -webkit-appearance: none;
    box-shadow: none !important;
    outline: none;
    width: 65px;
    border: 0;
    border-bottom: 1px solid rgba(122, 135, 153, 0.7);

    font-weight: 300;
    font-size: 12px;
    line-height: 13px;
    color: #7a8799;
    padding-bottom: 3px;
  }

  .trash-icon {
    display: flex;
    align-items: center;
    color: #4a90e2;
    cursor: pointer;
    font-weight: 300;
    font-size: 12px;
    line-height: 13px;
    margin-right: 10px;

    img {
      width: 14px;
      margin-right: 8px;
    }
  }

  .monthly-input__mask {
    background-color: #fff;
    -webkit-appearance: none;
    box-shadow: none !important;
    outline: none !important;
    max-width: 35px;
    border: 0 !important;
    border-bottom: 1px solid rgba(122, 135, 153, 0.7);
    font-weight: 300;
    font-size: 12px;
    line-height: 13px;
    color: #7a8799;
    padding-bottom: 3px;
    margin: 0 10px;
    text-align: start;
    padding-left: -10px;
  }
`;

export const CreditPorcentageWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 90px;
  position: relative;

  img {
    width: 18px;
    height: 18px;
    cursor: pointer;
  }

  input {
    background-color: #fff;
    -webkit-appearance: none;
    box-shadow: none !important;
    outline: none;
    max-width: 35px;
    border: 0;
    border-bottom: 1px solid rgba(122, 135, 153, 0.7);

    font-weight: 300;
    font-size: 12px;
    line-height: 13px;
    color: #7a8799;
    padding-bottom: 3px;
    margin: 0 10px;
    text-align: start;
    padding-left: -10px;
  }

  span {
    font-size: 12px;
    position: absolute;
    right: 28px;
    top: 1px;
    &::before {
      content: '%';
    }
  }
`;

export const NumberFormatInput = styled(NumberFormat)`
  background-color: #fff;
  -webkit-appearance: none;
  box-shadow: none !important;
  outline: none;
  max-width: 80px;
  border: 0;
  border-bottom: 1px solid rgba(122, 135, 153, 0.7);

  font-weight: 300;
  font-size: 12px;
  line-height: 13px;
  color: #7a8799;
  padding-bottom: 3px;
  margin: 0 10px;
  text-align: start;
`;
